import client from "./client";

export default {
    async getTicketChannels(filters) {
        return client.parseResponse(client.parseResponse(await client.get('/ticket-channels', filters)));
    },

    async createTicketChannels(data) {
        return client.parseResponse(await client.post('/ticket-channels', data))
    },

    async getTicketChannel(id) {
        return client.parseResponse(await client.get('/ticket-channels/' + id));
    },

    async editTicketChannel(data) {
        return client.parseResponse(await client.put('/ticket-channels/' + data.id, data))
    },

    async deleteTicketChannel(data) {
        return client.parseResponse(await client.delete('/ticket-channels/' + data.id, data))
    }
}
